// extracted by mini-css-extract-plugin
export default {"container":"Review_container__qEWG-","stats":"Review_stats__6WARZ","flip":"Review_flip__9BNnd","no-cards":"Review_no-cards__J+pLy"};